import countries from 'country-list'
import { getTimezones } from 'timezone-list'

// Should really connect this app to Vuex so that we can manage these things in a proper way!
export let ADDON_ACCESS = {
  local_rank: true,
  aviation_rank: false,
  phq_attendance: false
}

export const AVIATION_RANK_FILTERS = [
  {value: 'aviation-rank', label: 'Aviation Rank level', help: 'Estimated aviation impact of the event.'},
  {value: 'aviation-rank-range', label: 'Aviation Rank range', help: 'Estimated local impact of the event.'}
]

export const PHQ_ATTENDANCE_FILTER = {value: 'phq-attendance', label: 'PHQ Attendance', help: 'Predicted attendance for the event.'}

export const FILTER_OPTIONS = {
  timezones: getTimezones(),
  ranks: [
    {
      value: 1,
      label: '1 - Minor (rank between 0 and 20)'
    },
    {
      value: 2,
      label: '2 - Moderate (rank between 21 and 40)'
    },
    {
      value: 3,
      label: '3 - Important (rank between 41 and 60)'
    },
    {
      value: 4,
      label: '4 - Significant (rank between 61 and 80)'
    },
    {
      value: 5,
      label: '5 - Major (rank between 81 and 100)'
    }
  ],
  categories: [
    'school-holidays',
    'public-holidays',
    'observances',
    'politics',
    'conferences',
    'expos',
    'concerts',
    'festivals',
    'performing-arts',
    'sports',
    'community',
    'daylight-savings',
    'airport-delays',
    'severe-weather',
    'disasters',
    'terror',
    'academic',
    'health-warnings'
  ],
  limits: [500, 50],
  labels: [],
  states: [
    'active',
    'deleted'
  ],
  withinUnits: [
    {value: 'm', label: 'Meters'},
    {value: 'km', label: 'Kilometers'},
    {value: 'ft', label: 'Feet'},
    {value: 'mi', label: 'Miles'}
  ],
  withinMetrics: [
    {value: 'demand', label: 'Demand'},
    {value: 'lead', label: 'Lead'},
    {value: 'span', label: 'Span'}
  ],
  countries: countries().getData(),
  ltComparisonTypes: [
    {value: 'lt', label: 'Less than'},
    {value: 'lte', label: 'Less than or equals'}
  ],
  gtComparisonTypes: [
    {value: 'gt', label: 'Greater than'},
    {value: 'gte', label: 'Greater than or equals'}
  ],
  filterTypes: [
    {value: 'active', label: 'Active date', help: 'The date from and/or to the date the event intersects with.'},
    {value: 'category', label: 'Category', help: 'The category of the event.'},
    {value: 'country', label: 'Country', help: 'Country that the event takes/took place in.'},
    {value: 'end', label: 'End date', help: 'The date from and/or to the date when the event ends.'},
    {value: 'label', label: 'Labels', help: 'The labels associated with the event.'},
    {value: 'local-rank', label: 'Local Rank level', help: 'Estimated local impact of the event.'},
    {value: 'local-rank-range', label: 'Local Rank range', help: 'Estimated local impact of the event.'},
    {value: 'place', label: 'Place', help: 'Location that the event takes/took place in.'},
    {value: 'query', label: 'Query', help: 'A full-text search query.'},
    {value: 'rank', label: 'Rank level', help: 'Estimated impact of the event.'},
    {value: 'rank-range', label: 'Rank range', help: 'Estimated impact of the event.'},
    {value: 'start', label: 'Start date', help: 'The date from and/or to the date when the event starts.'},
    {value: 'state', label: 'Event Status', help: 'The publication status of the event.'},
    {
      value: 'updated',
      label: 'Updated date',
      help: 'The date from and/or to the date when the event was last modified.'
    },
    {
      value: 'within',
      label: 'Within',
      help: 'Latitude and longitude of the location that the event takes/took place in.'
    }
  ],
  dateTypes: [
    {value: 'start', label: 'Start', help: ''},
    {value: 'end', label: 'End', help: ''},
    {value: 'active', label: 'Active', help: ''},
    {value: 'updated', label: 'Updated', help: ''}
  ],
  placeRangeTypes: [
    'exact',
    'scope'
  ]
}

export const FILTER_DEFAULTS = {
  place: {
    type: 'scope'
  },
  within: {
    unit: {
      value: 'km', label: 'Kilometers'
    }
  }
}

export const SINGLE_FILTERS = [
  'active',
  'aviation-rank',
  'aviation-rank-range',
  'category',
  'country',
  'deleted-reason',
  'end',
  'impact-rank',
  'label',
  'local-rank',
  'local-rank-range',
  'phq-attendance',
  'place',
  'query',
  'rank',
  'rank-range',
  'start',
  'updated',
  'within'
]

export const DATE_FILTERS = [
  'active',
  'start',
  'end'
]

export const EVENT_COUNT_WARNING_THRESHOLD = 10000
